<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col xl="10">
          <v-row>
            <v-col cols="12" md="6">
              <div class="display-2 font-weight-light mb-4">
                Uw huidige saldo :
                {{
                  (this.$store.getters["user/user"].prepaid / 100) | currency
                }}
              </div>
              <div class="font-weight-light mb-4">
                Je huidige saldo kun je opwaarderen via deze betaalmodule. Met
                dit saldo kun je betalen bij de kassa.
              </div>
              <v-btn color="primary" @click="balanceTopUpDialogModel = true"
                >Saldo opwaarderen</v-btn
              >
              <v-divider class="my-6"></v-divider>
              <div class="display-2 font-weight-light mb-4">
                Koppel andere kaarten
              </div>
              <div class="font-weight-light mb-4">
                Je kunt barcodes van andere spaarkaarten koppelen met deze
                kaart.
              </div>
              <v-btn color="primary" @click="pairCardsDialogModel = true"
                >Koppel kaarten</v-btn
              >
              <v-divider class="my-6"></v-divider>
            </v-col>
            <v-divider class="mx-6 hidden-sm-and-down" vertical></v-divider>
            <v-col>
              <div class="display-2 font-weight-light mb-4">
                Jouw scanbare code
              </div>
              <div class="mb-4">
                Je kunt barcodes van andere spaarkaarten koppelen met deze
                kaart.
              </div>
              <v-row>
                <v-col sm="" cols="12">
                  <canvas id="qrcanvas"></canvas>
                  <div class="mt-4 body-1">
                    {{ this.$store.getters["user/user"].qr_code }}
                  </div>
                </v-col>
                <v-col sm="" cols="12" align-self="center">
                  <v-btn
                    class="primary ml-sm-8"
                    @click="downloadCanvas('qrcanvas')"
                    >Download</v-btn
                  >
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="secondary" style="height: 4px"></div>
    <div
      v-for="(campaign, index) in this.$store.getters['organization/campaigns']"
      :key="campaign.loyalty_system.name"
    >
      <div v-if="index !== 0" class="secondary my-6" style="height: 4px"></div>
      <v-container>
        <v-row justify="center">
          <v-col xl="10">
            <div class="display-2 font-weight-light">
              {{ campaign.loyalty_system.name }}
            </div>
            <div class="display-2 font-weight-light mb-4">
              <strong class="font-weight-bold">{{
                campaign.stamps_collected
              }}</strong>
              zegels gespaard
            </div>
            <v-row>
              <v-col
                lg="4"
                md="6"
                v-for="promotion in campaign.spin_promotions"
                :key="promotion.title"
              >
                <v-card shaped color="#fafafa">
                  <v-img
                    class="white--text align-end"
                    height="150px"
                    contain
                    :src="promotion.image"
                  >
                  </v-img>
                  <v-divider></v-divider>
                  <div class="pa-5">
                    <div class="headline mb-2">{{ promotion.title }}</div>
                    <div class="body-1">{{ promotion.body }}</div>
                  </div>
                  <v-divider></v-divider>
                  <div class="pa-5">
                    <v-card-actions class="pa-0">
                      <v-row no-gutters>
                        <v-col>
                          <v-btn
                            color="primary"
                            :disabled="!promotion.is_redeemable"
                            @click="openPromotion(promotion, campaign)"
                            class="mr-4"
                            >Ontgrendel
                          </v-btn>
                        </v-col>
                        <v-col align-self="center">
                          <div class="display-1">
                            Benodigde zegels :
                            <strong>{{ promotion.stamps_required }}</strong>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <PrintPromotionDialog
      v-model="printPromotionDialogModel"
      :chosen_promotion="chosenPromotion"
    ></PrintPromotionDialog>
    <BalanceTopUpDialog v-model="balanceTopUpDialogModel"></BalanceTopUpDialog>
    <PairCardsDialog v-model="pairCardsDialogModel"></PairCardsDialog>
  </div>
</template>

<script>
import PrintPromotionDialog from "./components/PrintPromotionDialog";
import BalanceTopUpDialog from "./components/BalanceTopUpDialog";
import PairCardsDialog from "./components/PairCardsDialog";
export default {
  components: {
    PairCardsDialog,
    BalanceTopUpDialog,
    PrintPromotionDialog
  },
  mounted() {
    let QRCode = require("qrcode");
    let canvas = document.getElementById("qrcanvas");
    QRCode.toCanvas(
      canvas,
      this.$store.getters["user/user"].qr_code,
      {
        width: 200,
        color: {
          light: "#fafafa"
        },
        margin: 0
      },
      function() {}
    );
  },
  name: "Home",
  data() {
    return {
      printPromotionDialogModel: false,
      chosenPromotion: { item: {}, campaign: { loyalty_system: {} } },
      balanceTopUpDialogModel: false,
      pairCardsDialogModel: false
    };
  },
  methods: {
    downloadCanvas(id) {
      let link = document.createElement("a");
      link.download = "qr-promotion.png";
      link.href = document.getElementById(id).toDataURL();
      link.click();
    },
    openPromotion(item, campaign) {
      this.chosenPromotion.item = item;
      this.chosenPromotion.campaign = campaign;
      this.printPromotionDialogModel = true;
    }
  }
};
</script>

<style scoped></style>
